module.exports = __webpack_public_path__ + "img/gift-fill.f6871693.svg";